import {EntitySummary} from 'constants/UserConstants';
import {bulkGetEntitySummariesByHandle} from 'dao/EntityDAO';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {
  modelFetched,
  modelInaccessible,
  modelKeysToInaccessibleInfoByKey,
} from 'models/ManagedModelsReduxActions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';

import {ManagedModelSelector} from '../reduceManagedModels';

export class EntitySummaryModelManager extends ModelManager<ManagedModelType.ENTITY_SUMMARY_BY_HANDLE> {
  constructor() {
    super(ManagedModelType.ENTITY_SUMMARY_BY_HANDLE);
  }

  async doFetchMulti(handles: Array<string>): Promise<void> {
    const modelsByKey = await bulkGetEntitySummariesByHandle(handles, true);
    getStore().dispatch(modelFetched(ManagedModelType.ENTITY_SUMMARY_BY_HANDLE, modelsByKey));

    /**
      Team names can be requested in this query, but are not included in the API results.
      This should not throw an error, which ModelManager would do by default. So we add
      teams to the list of inaccessible entities. This doesn't mean the team doesn't exist!
      Only that the team is not an accessible *entity*.
    */
    const handlesNotFound = handles.filter((id) => !modelsByKey[id]);
    if (handlesNotFound.length > 0) {
      getStore().dispatch(
        modelInaccessible(
          ManagedModelType.ENTITY_SUMMARY_BY_HANDLE,
          modelKeysToInaccessibleInfoByKey(handlesNotFound)
        )
      );
    }
  }

  getModel(modelKey: string): EntitySummary | null {
    return new ManagedModelSelector(getStore().getState()).getModel(
      ManagedModelType.ENTITY_SUMMARY_BY_HANDLE,
      modelKey
    );
  }
}
